
<div class="main-content" *ngIf="!isFromSM">
    <div class="container-fluid">
        <div class="card sq-card">
            <div class="card-header card-header-squirrel">
                <h4>{{this.translate.data['USERSMANAGEMENT'] | translate}}</h4>             

                <div class="clearfix"></div>
            </div>
            <div class="card-body" *ngIf="_userRoles.includes('MANAGE_USERS') || _userRoles.includes('TENANTADMIN') || _userRoles.includes('admin')">
                <div class="row">
                    <div class="col-md-8">
                        <a>
                        <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;margin-left: 5px" matTooltip="{{this.translate.data['ADDUSER'] | translate}}"
                            (click)="addUser()" [hidden]="!(_userRoles.includes('CREATE_USER') || _userRoles.includes('TENANTADMIN') || _userRoles.includes('admin'))">
                            Neuer Benutzer
                        </button>
                        </a>                   
                    </div>
                </div>
                <div class="row" *ngIf="!noUser">
                <!-- <div class="row"> -->
                        <div class="col-md-12 tenant-grouproles-board-body-table">
                        <div class="user-board-body-table">
                            <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                                <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                                <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                                        Squirrel's API rate limit has been reached. It will be reset in one minute.
                                </div>
                            </div>
                            <ag-grid-angular class="ag-theme-balham" style="width:100%;  height: 98%;  padding: 5px;"
                                    [overlayLoadingTemplate]="overlayLoadingTemplate"
                                    [gridOptions]="gridOptions" 
                                    (gridReady)="onGridReady($event)"
                                    [frameworkComponents]="frameworkComponents" 
                                    [userRoles]="_userRoles" 
                                    >
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>
                <!-- <div class="row" *ngIf="noUser">
                    <div class="col-md-12 tenant-grouproles-board-body-table">
                        <div class="user-board-body-table">
                            <ag-grid-angular class="ag-theme-balham" style="width:100%;  height: 100%;  padding: 5px;"
                                    [gridOptions]="gridOptions" 
                                    (gridReady)="onGridReady($event)"
                            >
                            </ag-grid-angular>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>

    </div>
</div>

<div class="card-body1" *ngIf="isFromSM && (_userRoles.includes('MANAGE_USERS') || _userRoles.includes('TENANTADMIN') || _userRoles.includes('admin'))">
    <div class="row">
        <div class="col-md-8">
            <a>
            <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 0px;margin-left: 5px" matTooltip="{{this.translate.data['ADDUSER'] | translate}}"
                (click)="addUser()" [hidden]="!(_userRoles.includes('CREATE_USER') || _userRoles.includes('TENANTADMIN') || _userRoles.includes('admin'))">
                Neuer Benutzer
            </button>
            </a>                   
        </div>
    </div>
    <div class="row" *ngIf="!noUser">
    <!-- <div class="row"> -->
            <div class="col-md-12 tenant-grouproles-board-body-table">
            <div class="user-board-body-table">
                <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                    <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                    <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                            Squirrel's API rate limit has been reached. It will be reset in one minute.
                    </div>
                </div>
                <ag-grid-angular class="ag-theme-balham" style="width:100%;  height: 85%;  padding: 5px;"
                        [overlayLoadingTemplate]="overlayLoadingTemplate"
                        [gridOptions]="gridOptions" 
                        (gridReady)="onGridReady($event)"
                        [frameworkComponents]="frameworkComponents" 
                        [userRoles]="_userRoles" 
                        >
                </ag-grid-angular>
            </div>
        </div>
    </div>
    <!-- <div class="row" *ngIf="noUser">
        <div class="col-md-12 tenant-grouproles-board-body-table">
            <div class="user-board-body-table">
                <ag-grid-angular class="ag-theme-balham" style="width:100%;  height: 100%;  padding: 5px;"
                        [gridOptions]="gridOptions" 
                        (gridReady)="onGridReady($event)"
                >
                </ag-grid-angular>
            </div>
        </div>
    </div> -->
</div>



